export function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

export function isEmptyObject(object) {
  return Object.keys(object).length === 0 && object.constructor === Object;
}
